// extracted by mini-css-extract-plugin
export var arrow = "fc-projects-module--arrow--4e36b";
export var items = "fc-projects-module--items--0853b";
export var next = "fc-projects-module--next--bcdd1";
export var prev = "fc-projects-module--prev--73d7b";
export var root = "fc-projects-module--root--ef6e5";
export var title = "fc-projects-module--title--4d33a";
export var white = "fc-projects-module--white--d9dcb";